module.exports = __webpack_public_path__ + "role.b17e7fe1f8adb0ae748702489e17ea60.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/selected/role.svg
// module id = 1150
// module chunks = 0